import React, { useEffect, useState } from "react";
import { getStorageUser } from "../../../helpers/api_helper";
import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import {
  getRouteConfigs,
  postImage,
  postRouteConfig,
  resourcesConcesionarios,
} from "../../../helpers/backend_helper";

import { ROUTES_CONFIGS } from "../../../constants/routeConfigs";
import NibbleInput from "../../../components/Fields/NibbleInput";
import ConcesionariosNotificationModal from "./ConcesionariosNotificationModal";
import { PROFILES } from "../../../components/VerticalLayout/SidebarContent";

const reportNotificationList = [
  {id: '', name: 'Seleccionar...'},
  {id: ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT, name: 'Resumen del día'},
]

const YESNO = [
  { label: "Si", value: true },
  { label: "No", value: false },
];

export const findValue = (resource, id) => {
  return resource.filter((e) => e.configuration_id == id)[0]?.value ?? "";
};

const getImage = (resource, id) =>
  resource.find((item) => item.configuration_id === id)?.image;

const ConfigurationRoute = () => {
  const title = "Configuraciones de Ruta";

  const user = getStorageUser();

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [concesionariosModal, setConcesionariosModal] = useState({show: false})

  const [concesionarios, setConcesionarios] = useState([]);

  const fetchConfigs = async () => {
    const resource = await getRouteConfigs();

    const notificationDailyReportValue = findValue(resource, ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT);

    validation.setValues({
      [ROUTES_CONFIGS.LOGO_URL]: findValue(resource, ROUTES_CONFIGS.LOGO_URL),
      [ROUTES_CONFIGS.ALIAS_ROUTE]: findValue(
        resource,
        ROUTES_CONFIGS.ALIAS_ROUTE
      ),
      [ROUTES_CONFIGS.BLOCK_CHANGE_SALIDAS]: findValue(
        resource,
        ROUTES_CONFIGS.BLOCK_CHANGE_SALIDAS
      ),
      [ROUTES_CONFIGS.COMPANY_NAME]: findValue(
        resource,
        ROUTES_CONFIGS.COMPANY_NAME
      ),
      [ROUTES_CONFIGS.COST_ADMINISTRATIVE]: findValue(
        resource,
        ROUTES_CONFIGS.COST_ADMINISTRATIVE
      ),
      [ROUTES_CONFIGS.FIRST_HOUR]: findValue(
        resource,
        ROUTES_CONFIGS.FIRST_HOUR
      ),
      [ROUTES_CONFIGS.GEO_INTERMEDIATE]: findValue(
        resource,
        ROUTES_CONFIGS.GEO_INTERMEDIATE
      ),
      [ROUTES_CONFIGS.HOUR_SHOW]: findValue(resource, ROUTES_CONFIGS.HOUR_SHOW),
      [ROUTES_CONFIGS.SPEED_MAX]: findValue(resource, ROUTES_CONFIGS.SPEED_MAX),
      [ROUTES_CONFIGS.COST_PASAJE]: findValue(
        resource,
        ROUTES_CONFIGS.COST_PASAJE
      ),
      [ROUTES_CONFIGS.COST_GASOLINE]: findValue(
        resource,
        ROUTES_CONFIGS.COST_GASOLINE
      ),
      [ROUTES_CONFIGS.TITLE_REPORT]: findValue(
        resource,
        ROUTES_CONFIGS.TITLE_REPORT
      ),
      /*
      [ROUTES_CONFIGS.MINUTES_TO_EDIT]: findValue(
        resource,
        ROUTES_CONFIGS.MINUTES_TO_EDIT
      ),
      [ROUTES_CONFIGS.MINUTES_TO_DELETE]: findValue(
        resource,
        ROUTES_CONFIGS.MINUTES_TO_DELETE
      ),
      */
     [ROUTES_CONFIGS.NON_ATTENDANCE_DAYS]: findValue(
       resource,
       ROUTES_CONFIGS.NON_ATTENDANCE_DAYS
      ),
      [ROUTES_CONFIGS.EMAIL_ADMIN]: findValue(
        resource,
        ROUTES_CONFIGS.EMAIL_ADMIN
      ),
      [ROUTES_CONFIGS.LOGO_FILE]: findValue(resource, ROUTES_CONFIGS.LOGO_FILE),
      [ROUTES_CONFIGS.MINUTES_PASAJE_BEFORE_START]: findValue(
        resource,
        ROUTES_CONFIGS.MINUTES_PASAJE_BEFORE_START
      ),
      [ROUTES_CONFIGS.MINUTES_PASAJE_AFTER_END]: findValue(
        resource,
        ROUTES_CONFIGS.MINUTES_PASAJE_AFTER_END
      ),
      [ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT_TIME]: findValue(
        resource,
        ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT_TIME
      ),
      //[ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT]: notificationDailyReportValue ? JSON.parse(notificationDailyReportValue) : '',
      report_notifications: '',
    });

    const image = getImage(resource, ROUTES_CONFIGS.LOGO_FILE);

    setImage(image);
  };

  useEffect(() => {
    const loadConf = async () => {
      setLoading(true);
      await fetchConfigs();
      setLoading(false);
    }
    loadConf();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      [ROUTES_CONFIGS.FIRST_HOUR]: "",
      [ROUTES_CONFIGS.COST_PASAJE]: "",
      [ROUTES_CONFIGS.COST_ADMINISTRATIVE]: "",
      [ROUTES_CONFIGS.BLOCK_CHANGE_SALIDAS]: "",
      [ROUTES_CONFIGS.SPEED_MAX]: "",
      [ROUTES_CONFIGS.ALIAS_ROUTE]: "",
      [ROUTES_CONFIGS.HOUR_SHOW]: "",
      [ROUTES_CONFIGS.COST_GASOLINE]: "",
      [ROUTES_CONFIGS.TITLE_REPORT]: "",
      /*
      [ROUTES_CONFIGS.MINUTES_TO_EDIT]: "",
      [ROUTES_CONFIGS.MINUTES_TO_DELETE]: "",
*/
      [ROUTES_CONFIGS.NON_ATTENDANCE_DAYS]: "",
      [ROUTES_CONFIGS.LOGO_FILE]: "",
      [ROUTES_CONFIGS.EMAIL_ADMIN]: "",

      [ROUTES_CONFIGS.MINUTES_PASAJE_BEFORE_START]: "",
      [ROUTES_CONFIGS.MINUTES_PASAJE_AFTER_END]: "",
      [ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT_TIME]: "1",
      //[ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT]: {},
      report_notifications: '',
    },
    validationSchema: Yup.object({
      [ROUTES_CONFIGS.FIRST_HOUR]: Yup.string()
        .nullable(true)
        .required("Requerido"),
      [ROUTES_CONFIGS.COST_PASAJE]: Yup.number()
        .nullable(true)
        .required("Requerido"),
      [ROUTES_CONFIGS.COST_ADMINISTRATIVE]: Yup.number().required("Requerido"),
      [ROUTES_CONFIGS.COST_GASOLINE]: Yup.number().required("Requerido"),
      [ROUTES_CONFIGS.MINUTES_TO_EDIT]: Yup.number().nullable(true),
      [ROUTES_CONFIGS.MINUTES_TO_DELETE]: Yup.number().nullable(true),
      [ROUTES_CONFIGS.NON_ATTENDANCE_DAYS]: Yup.number().nullable(true),
      [ROUTES_CONFIGS.EMAIL_ADMIN]: Yup.string()
        .email("Debe ser un email valído")
        .nullable(true),
      [ROUTES_CONFIGS.LOGO_FILE]: Yup.string().nullable(true),
      [ROUTES_CONFIGS.MINUTES_PASAJE_BEFORE_START]: Yup.number().nullable(true),
      [ROUTES_CONFIGS.MINUTES_PASAJE_AFTER_END]: Yup.number().nullable(true),
      [ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT_TIME]: Yup.string().nullable(true),
      //[ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT]: Yup.object().nullable(true),
      report_notifications: Yup.string().nullable(true),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const save = async (data) => {
    try {
      const cleanData = {
        ..._.omit(data, ['report_notifications']), //solo para seleccionar el tipo de reporte
        //[ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT]: data[ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT] ? JSON.stringify(data[ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT]) : ''
      };

      setLoadingBtn(true);
      const response = await postRouteConfig(cleanData);
      await fetchConfigs();
    } catch (err) {
      console.error(err);
    }
    setLoadingBtn(false);
  };

  const handleOpenConcesionariosModal = () => {
    if(validation.values.report_notifications) {
      setConcesionariosModal({ show: true });
    }
  }

  useEffect(handleOpenConcesionariosModal, [validation.values.report_notifications])
  
  useEffect(() => {
    const getConcesionarios = async () => {
      let params = { params: {select: true} };
      const response = await resourcesConcesionarios("get", params);

      setConcesionarios(response.data);
    };
    getConcesionarios();
  }, []);

  document.title = "Configuración de Ruta | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="">
            <div className="card">
              <div className="card-header">
                <Breadcrumb title={title} breadcrumbItem={title} />
              </div>
              <div className="card-body">
                {loading}
                {loading && <Spinner size="sm"></Spinner>}
                {!loading && (
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="row">
                      <NibbleInput
                        md={4}
                        label="Primera Hora de Salida:"
                        fieldName={ROUTES_CONFIGS.FIRST_HOUR}
                        fieldType="time"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Bloquear Cambio de Salidas(5 min):"
                        fieldName={ROUTES_CONFIGS.BLOCK_CHANGE_SALIDAS}
                        fieldType="select"
                        validation={validation}
                        selectItems={YESNO}
                        selectOptionLabel={(e) => e.label}
                        selectOptionValue={(e) => e.value}
                      />

                      <NibbleInput
                        md={4}
                        label="Velocidad Máxima (km/h):"
                        fieldName={ROUTES_CONFIGS.SPEED_MAX}
                        fieldType="number"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Precio del pasaje:"
                        fieldName={ROUTES_CONFIGS.COST_PASAJE}
                        fieldType="number"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Pago diario por administración:"
                        fieldName={ROUTES_CONFIGS.COST_ADMINISTRATIVE}
                        fieldType="number"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Alias:"
                        fieldName={ROUTES_CONFIGS.ALIAS_ROUTE}
                        fieldType="text"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Horas de muestra:"
                        fieldName={ROUTES_CONFIGS.HOUR_SHOW}
                        fieldType="number"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Costo gasolina:"
                        fieldName={ROUTES_CONFIGS.COST_GASOLINE}
                        fieldType="number"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Titulo de reportes:"
                        fieldName={ROUTES_CONFIGS.TITLE_REPORT}
                        fieldType="text"
                        validation={validation}
                      />
                      {false && (
                        <>
                          <NibbleInput
                            md={4}
                            label="Minutos para bloqueo de edición de salidas:"
                            fieldName={ROUTES_CONFIGS.MINUTES_TO_EDIT}
                            fieldType="number"
                            validation={validation}
                          />

                          <NibbleInput
                            md={4}
                            label="Minutos para bloqueo de eliminación de salidas:"
                            fieldName={ROUTES_CONFIGS.MINUTES_TO_DELETE}
                            fieldType="number"
                            validation={validation}
                          />
                        </>
                      )}
                      <NibbleInput
                        md={4}
                        label="Días para baja automática de operadores:"
                        fieldName={ROUTES_CONFIGS.NON_ATTENDANCE_DAYS}
                        fieldType="number"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Email admin:"
                        fieldName={ROUTES_CONFIGS.EMAIL_ADMIN}
                        fieldType="text"
                        validation={validation}
                      />

                      <NibbleInput
                        md={4}
                        label="Modalidad reporte resumen diario:"
                        fieldName={ROUTES_CONFIGS.NOTIFICATION_DAILY_SUMMARY_REPORT_TIME}
                        fieldType="select"
                        validation={validation}
                        selectItems={[
                          { id: "1", name: "24 horas desde inicio del día (por defecto)" },
                          { id: "2", name: "24 horas desde medio día anterior" },
                        ]}
                      />

                      <NibbleInput
                        md={6}
                        label="Pasaje Minutos antes:"
                        fieldName={ROUTES_CONFIGS.MINUTES_PASAJE_BEFORE_START}
                        fieldType="text"
                        validation={validation}
                      />

                      <NibbleInput
                        md={6}
                        label="Pasaje Minutos después:"
                        fieldName={ROUTES_CONFIGS.MINUTES_PASAJE_AFTER_END}
                        fieldType="text"
                        validation={validation}
                      />

                      <NibbleInput
                        md={12}
                        label="Logo:"
                        fieldName={ROUTES_CONFIGS.LOGO_FILE}
                        fieldType="image"
                        validation={validation}
                        postFileFunction={postImage}
                        itemFile={image}
                      />

                      <Col md={12} className="text-center mt-3">
                        <Button
                          color="primary"
                          type="submit"
                          disabled={loadingBtn}
                        >
                          {loadingBtn && <Spinner size="sm"></Spinner>}{" "}
                          <i className="fa fa-save"></i> Guardar
                        </Button>{" "}
                      </Col>
                    </div>
                  </Form>
                )}
              </div>
            </div>
          </div>
          {concesionariosModal.show && (
            <ConcesionariosNotificationModal
              modal={concesionariosModal}
              setModal={setConcesionariosModal}
              validation={validation}
              concesionarios={concesionarios}
              reportNotificationList={reportNotificationList}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConfigurationRoute;
